// External modules
import acHTTPClient from 'services/ACHTTPClient';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';

// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;

const getOptionsError = error => {
  return {
    type: constants.GET_OPTIONS_ERROR,
    error,
  };
};

const getOptionsSuccess = options => {
  return {
    type: constants.GET_OPTIONS_SUCCESS,
    options: options,
  };
};

const getOptionsByFiltersError = error => {
  return {
    type: constants.GET_OPTIONS_BY_FILTERS_ERROR,
    error,
  };
};

const getOptionsByFiltersSuccess = options => {
  return {
    type: constants.GET_OPTIONS_BY_FILTERS_SUCCESS,
    options: options,
  };
};

const getOptions = () => {
  let apiURL = `${experienceAPIURL}/options`;
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getOptionsError(response.statusText));
        }
        dispatch(getOptionsSuccess(response.data.data));
      })
      .catch(error => {
        dispatch(getOptionsError(error));
      });
  };
};

const getOptionsByFilters = filterBy => {
  let apiURL = `${experienceAPIURL}/options?${filterBy}`;
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getOptionsByFiltersError(response.statusText));
        }
        dispatch(getOptionsByFiltersSuccess(response.data.data));
      })
      .catch(error => {
        dispatch(getOptionsByFiltersError(error));
      });
  };
};

export { getOptions, getOptionsByFilters };
